// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gc-3";
export var downloadButton = "_gc-4";
export var fileContainer = "_gc-9 _gc-7";
export var fileContainerBase = "_gc-7";
export var fileContainerBaseSm = "_gc-a _gc-7";
export var fileContainerFixedHeight = "_gc-8 _gc-7";
export var fileContainerFixedHeightSm = "_gc-c _gc-a _gc-7";
export var fileContainerSm = "_gc-b _gc-a _gc-7";
export var fileInfo = "_gc-5";
export var fileInfoWidthRestricted = "_gc-6";
export var fileType = "_gc-1";
export var fileTypeName = "_gc-2";
export var fileTypeSm = "_gc-d _gc-1";
export var image = "_gc-0";
export var link = "_gc-f";
export var overflowEllipsis = "_gc-e";